<div class="search-wrapper" (appClickOutside)="close(); clear()">
  <div class="information">
    <i class="icon-information-16" [appTooltip]="'Translation.Globalsearchicon' | translate" [tooltipPosition]="'bottomLeft'" [tooltipTheme]="'white'"></i>
  </div>
  <div class="search">
    <div class="search-box">
      <i class="icon-search-input-default-24 search-icon"></i>
      <input type="text"
             [placeholder]="'Translation.Searchby_owner_poc_bookingid_reseravtionname' | translate"
             [formControl]="search"
             (focus)="search?.markAsTouched()"
             (focusout)="search?.markAsUntouched()" />
      <i class="icon-close-default-16 close-icon" *ngIf="search?.value && !showLoader" (click)="clear()"></i>
      <img *ngIf="showLoader" src="/assets/icons/Deloitte-Spinner.svg" />
    </div>
    <div class="list-wrapper" *ngIf="bookings.length || waitlists.length || meetingWaitList.length || virtualBookings.length">
      <app-tabs [hasContent]="false" (tabChanged)="tabChange($event)">
        <app-tab *ngFor="let tab of tabs" [id]="tab.value" [heading]="tab?.label | translate" [active]="tab.selected" [counter]="tab?.counter"></app-tab>
      </app-tabs>
      <div class="list-wrapper__body" [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'all'">
          <ng-container *ngIf="bookings.length">
            <label class="all-head">{{'Translation.Meetings_bookings' | translate}}</label>
            <div class="items">
              <ng-container *ngFor="let item of bookings | slice : 0 : 10">
                <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
              </ng-container>
            </div>
            <hr />
          </ng-container>
          <!-- Phase 1 - virtual options, and waitlist in gloabl search -->
          <ng-container *ngIf="meetingWaitList.length || virtualBookings.length">
            <label class="all-head">{{'Translation.Meeting_requests' | translate}}</label>
            <!-- <div class="items" *ngIf="virtualBookings.length">
              <ng-container *ngFor="let item of virtualBookings | slice : 0 : virtualBookingSlice">
                <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
              </ng-container>
            </div> -->
            <div class="items" *ngIf="meetingWaitList.length">
              <ng-container *ngFor="let item of meetingWaitList | slice : 0 : meetingRequestSlice">
                <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
              </ng-container>
            </div>
            <hr />
          </ng-container>
          <ng-container *ngIf="waitlists.length">
            <label class="all-head">{{'Translation.Waitlist' | translate}}</label>
            <div class="items">
              <ng-container *ngFor="let item of waitlists | slice : 0 : 10">
                <div [ngTemplateOutlet]="waitlistItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'booking'">
          <div class="items" *ngIf="bookings.length">
            <ng-container *ngFor="let item of bookings | slice : 0 : 30">
              <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
            </ng-container>
          </div>
          <div *ngIf="!bookings.length" [ngTemplateOutlet]="noResultFound"></div>
        </ng-container>
        <ng-container *ngSwitchCase="'meetingWaitlist'">
          <div class="items" *ngIf="virtualBookings.length">
            <ng-container *ngFor="let item of virtualBookings | slice : 0 : virtualBookingSlice">
              <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
            </ng-container>
          </div>
          <div class="items" *ngIf="meetingWaitList.length">
            <ng-container *ngFor="let item of meetingWaitList | slice : 0 : meetingRequestSlice">
              <div [ngTemplateOutlet]="meetingItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
            </ng-container>
          </div>
          <div *ngIf="!meetingWaitList.length && !virtualBookings.length" [ngTemplateOutlet]="noResultFound"></div>
        </ng-container>
        <ng-container *ngSwitchCase="'waitlist'">
          <div class="items" *ngIf="waitlists.length">
            <ng-container *ngFor="let item of waitlists | slice : 0 : 30">
              <div [ngTemplateOutlet]="waitlistItem" [ngTemplateOutletContext]="{ $implicit: item }"></div>
            </ng-container>
          </div>
          <div *ngIf="!waitlists.length" [ngTemplateOutlet]="noResultFound"></div>
        </ng-container>
      </div>
      <div [ngTemplateOutlet]="limitExceeds" *ngIf="limitReached"></div>
    </div>
    <div class="no-results-found" *ngIf="noResultsFound">{{'Translation.Noresultsfound' | translate}}</div>
  </div>
</div>
<ng-template #noResultFound>
  <div class="no-result-found">
    <div class="no-result-found__body">
      <img src="/assets/Images/no-results-found.svg" />
      <p class="text">{{ 'Translation.Noresultsfound' | translate }}</p>
      <p>{{'Translation.Refine_your_search' | translate}}</p>
    </div>
  </div>
</ng-template>
<ng-template #meetingItem let-item>
  <div class="meeting-item">
    <div class="meeting-details">
      <p class="active" appEllipsisTooltip="" [innerHTML]="item.meetingName | appHighlight : search?.value" (click)="navigatToMeeting(item)"></p>
      <p class="divider"></p>
      <p [innerHTML]="item.meetingId | appHighlight : search?.value"></p>
      <p class="divider"></p>
      <p>
        <label class="label">{{'Translation.Owner' | translate}}: </label>
        <span appEllipsisTooltip="" [innerHTML]="item.owner?.name | appHighlight : search?.value"></span>
      </p>
      <p class="divider"></p>
      <p>
        <label class="label">{{'Translation.Poc' | translate}}: </label>
        <span appEllipsisTooltip="" [innerHTML]="item.poc?.name | appHighlight : search?.value"></span>
      </p>
      <app-status [status]="item.reservationStatus"></app-status>
      
    </div>
    <div class="item-details">
      <p class="active" appEllipsisTooltip="" [innerHTML]="item.name | appHighlight : search?.value" (click)="navigateToDetails(item)"></p>
      <p class="divider"></p>
      <p>
        <span *ngIf="item.itemType !== RESERVATION_ITEM_TYPES.VirtualBooking" [innerHTML]="item.id | appHighlight : search?.value"></span>
        <span
          *ngIf="item.itemType === RESERVATION_ITEM_TYPES.VirtualBooking"
          [innerHTML]="item.virtualBookingNumber | appHighlight : search?.value"
        ></span>
      </p>
      <p class="divider"></p>
      <p>{{ item.startDate | mPipe : "MM/DD/YY" }}{{ item.isMidnightSpanning ? " - " + (item.endDate | mPipe : "MM/DD/YY") : "" }}</p>
      <p class="divider"></p>
      <ng-container *ngIf="item.itemType === RESERVATION_ITEM_TYPES.SpaceBooking">
        <p appEllipsisTooltip="">{{ item.buildingName }}</p>
        <p class="divider"></p>
        <p appEllipsisTooltip="">{{ item.space }}</p>
        <app-status [status]="item.status"></app-status>
      </ng-container>
      <ng-container *ngIf="item.itemType !== RESERVATION_ITEM_TYPES.SpaceBooking">
        <ng-container *ngIf="item.itemType === RESERVATION_ITEM_TYPES.MeetingRequest">
          <p>{{ item.buildingName }}</p>
          <p class="divider"></p>
        </ng-container>
        <p>
          <span *ngIf="item.itemType === RESERVATION_ITEM_TYPES.MeetingRequest">{{'Translation.In-office' | translate}}</span>
          <span *ngIf="item.itemType === RESERVATION_ITEM_TYPES.VirtualBooking">{{'Translation.Virtual' | translate}}</span>
        </p>
        <app-status [status]="item.status"></app-status>
      </ng-container> 
    </div>
  </div>
</ng-template>
<ng-template #waitlistItem let-item>
  <div class="waitlist-item">
    <div class="name">
      <p class="active" [innerHTML]="item.owner?.name | appHighlight : search?.value" (click)="navigateWaitlist(item)"></p>
      <app-status [status]="item.status"></app-status>
    </div>
    <div class="building">
      <p>{{ item.startDate | mPipe : "MM/DD/YY" }}{{ item.isMidnightSpanning ? " - " + (item.endDate | mPipe : "MM/DD/YY") : "" }}</p>
      <p class="divider"></p>
      <p>{{ item.buildingName }}</p>
    </div>
  </div>
</ng-template>
<ng-template #limitExceeds>
  <div class="limit-exceeds">
   {{'Translation.Tomanymatches' | translate}}
  </div>
</ng-template>
